import { render, staticRenderFns } from "./createorupdatebarcode.vue?vue&type=template&id=17cbf3bf"
import script from "./createorupdatebarcode.vue?vue&type=script&lang=js"
export * from "./createorupdatebarcode.vue?vue&type=script&lang=js"
import style0 from "./createorupdatebarcode.vue?vue&type=style&index=0&id=17cbf3bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports